<template>
	<div class="my_excelup">
		<div>
			<input type="file" @change="importExcel(this)" id="imFile-InputDetail2" style="display: none"
				accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
		</div>

		<!-- 弹窗编辑 start -->
		<div v-show="show_tan" class="pre_tan">
			<span class="pre_tan_bg" @click="closeshow"></span>
			<div class="pre_tan_conten">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">
					<div class="pre_leve_one" v-loading="element_loading" element-loading-text="拼命加载中......"
						element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

						<div class="content_edit">
							<div class="content_edit_item">
								<button @click="uploadFile">导入数据</button>
							</div>
							<div class="content_edit_item">
								<button @click="savedata">保存数据</button>
							</div>
							<div class="content_edit_item">
								<button @click="downloaddemo">下载数据模板</button>
							</div>
							<div class="content_edit_item">
								<button @click="downloaddata">下载错误数据</button>
							</div>
						</div>

					</div>
					<div class="pre_leve_two">
						<!-- 这里放相关内容-->
						<!-- table部分 -->
						<div id="pre_tab" class="pre_tab" v-loading="element_loading" element-loading-text="拼命加载中......"
							element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
							<table class="pre_dataintable_new" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header">
									<td v-for="(t,index) in tab_th" :key="index">{{t.name}}</td>
								</tr>
								<tr v-for="data_tr in show_Data">
									<!-- <a href="#"> -->
									<td v-for="(d,index) in data_tr" :key="index">
										<a href="#">{{d.val}}</a>
									</td>
									<!-- </a> -->
								</tr>
							</table>
						</div>
						<div class="red">
							<h5>注意1:日期格式:YYYY-MM-DD,数字+英文格式样例:^+A132B456。</h5>
						</div>
						<div class="red">
							<h5>注意2:如果读取到的数据为 Infinity ,请在Excel中对应内容前加个^符号</h5>
						</div>
						<div class="red">
							<h5>注意3:如果导入数据没有响应,请刷新下界面。</h5>
						</div>
						<!-- 分页部分 -->
						<div class="pre_page" v-show="show_page">
							<ul style="text-align: right; margin-right: 20px;">
								<li>
									当前页：<label>{{ nowpage }}</label>&nbsp; 合计页：<label>{{ maxpage }}</label>&nbsp;&nbsp;
									<a href="#" @click="firstpage">首页</a>|
									<a href="#" @click="beforepage">上一页</a>|
									<a href="#" @click="nextpage">下一页</a>|
									<a href="#" @click="lastpage">尾页</a>
									<input type="text" v-model="jumppage" value="" /><a href="#" @click="gopage"
										class="go">Go</a>
								</li>
							</ul>
						</div>

					</div>

					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>

		<!-- 弹窗编辑 end -->
		<table v-show="show_error" id="pre_errortable" class="pre_dataintable" border="1" cellpadding="2"
			cellspacing="1">
			<!-- <tr class="tab_header">
        <td v-for="(t,index) in tab_th" :key="index">{{t.key}}</td>
      </tr> -->
			<tr>
				<td v-for="(d,index) in tab_th" :key="index">
					<a href="#">{{d.name}}</a>
				</td>
			</tr>
			<tr v-for="data_tr in error_Data">
				<!-- <a href="#"> -->
				<td v-for="(d,index) in data_tr" :key="index">
					<a href="#">{{d.val}}</a>
				</td>
				<!-- </a> -->
			</tr>
		</table>

		<table v-show="show_error" id="pre_demoDetail" class="pre_dataintable" border="1" cellpadding="2" cellspacing="1">
			<tr class="tab_header">
				<td v-for="(t,index) in tab_th" :key="index">{{t.key}}</td>
			</tr>
			<tr>
				<!-- <a href="#"> -->
				<td v-for="(d,index) in tab_th" :key="index">
					<a href="#">{{d.name}}</a>
				</td>
				<!-- </a> -->
			</tr>
		</table>
		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

	</div>
</template>

<script>
	/*
名称：导入Excel
日期：2019-06-06
作者：hj
目标：
1、默认展示一个按钮,
2、一定条件的通用模式上传 通过字母匹配字段。
cnpm install xlsx
cnpm install moment
*/
	// 引入xlsx
	var XLSX = require("xlsx");
	import moment from 'moment'; //解析导入excel 日期格式问题
	import table2excel from '@/utils/jquery.table2excel.js';

	import api from '@/utils/type.js';
	import {
		Method_Common,
		Method_CommonLong,
		Method_CommonLongLong,
		Method_TableAll
	} from '@/utils/loadhttpdata.js';


	import {
		base_encode
	} from "@/utils/base64.js";

	import {
		GetShort,
		BackSpecial,
		DeleteSpecialWord
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	import {
		dateFormatEasybyChina,
		dateFormatbyChina,
		Word_Right_Delete,
		checkStringByForm
	} from '@/utils/method.js';

	export default {
		name: "pre_excel_up_new",
		data() {
			return {
				element_loading: false,
				show_exceldata: false,
				imFile: "", // 导入文件el
				xlsxJson: '',
				errorDialog: false, // 错误信息弹窗
				errorMsg: "", // 错误信息内容
				excelData: [], // 总的Excel信息
				show_Data: [], // 展示Excel信息
				error_Data: [], // 展示Excel信息
				// 弹窗编辑
				show_tan: false,
				show_error: false,

				tab_th: [],

				show_page: false,
				maxpage: '',
				nowpage: '',
				jumppage: '',
				perpage: 20,

				errnum: ''
			};
		},
		props: {
			/* 标题 */
			pre_th: {
				type: Array,
				default: []
			},
			/* 操作 */
			api_url: {
				type: String,
				default: ''
			},
			api_action: {
				type: String,
				default: ''
			},
			api_method: {
				type: String,
				default: ''
			},
			api_check: {
				type: String,
				default: ''
			},
		},
		created: function() {
			this.nowpage = 1;
		},
		mounted() {
			this.imFile = document.getElementById("imFile-InputDetail2");
		},
		methods: {
			show_edit: function() {
				this.tab_th = [];
				this.show_Data = [];
				this.excelData = [];
				this.nowpage = 1;

				console.log(this.pre_th);

				// 判断
				this.tab_th.push({
					"key": "id",
					"name": "序号",
					"val": ""
				})

				// this.pre_th[i].excel=='1' 生成模版 标记

				for (let i = 0; i < this.pre_th.length; i++) {
					if (this.pre_th[i].p == '1' || this.pre_th[i].excel == '1') {
						if (this.pre_th[i].type == 'radio') {
							// console.log(this.pre_th[i]);
							let o = {};
							o.key = this.pre_th[i].key;
							o.name = this.pre_th[i].name[0].name;
							o.val = this.pre_th[i].name[0].val;
							o.p = this.pre_th[i].name[0].p;
							this.tab_th.push(o);
						} else {
							this.tab_th.push(this.pre_th[i]);
						}
					}
				}
				this.tab_th.push({
					"key": "upflag",
					"name": "上传状态",
					"val": ""
				});

				this.show_tan = true;
				console.log('导入弹窗。。。。。');
				var Hg = $(document).height();
				// 设置背景高度
				$(".pre_tan_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pre_tan_bg").fadeIn("3000");
				$(".pre_tan_conten").fadeIn("3000");
			},
			closeshow: function() {
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_tan_conten").fadeOut("3000");
				this.show_tan = false;
				this.tab_th = [];
				this.show_Data = [];
				this.excelData = [];
				this.nowpage = 1;
				this.$emit('excelup-event');
			},
			uploadFile: function() {
				// document.getElementById("imFile").click();
				// 点击导入按钮
				this.imFile = '';
				this.imFile = document.getElementById("imFile-InputDetail2");

				this.imFile.click();
			},
			importExcel: function(file) {
				// 导入Excel并解析
				this.element_loading = true;
				let obj = this.imFile;
				if (!obj.files) {
					this.element_loading = false;
					return;
				}
				var f = obj.files[0];
				const types = f.name.split('.')[1];
				// console.log('文件类型 '+types);
				const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types);
				if (!fileType) {
					this.element_loading = false;

					this.$message({
						message: '格式错误！请重新选择',
						type: 'warning'
					});
					return
				}
				// var rABS = false; //是否将文件读取为二进制字符串
				var reader = new FileReader();
				let $t = this;
				reader.onload = function(e) {
					var data = e.target.result;
					if ($t.rABS) {
						$t.wb = XLSX.read(btoa(this.fixdata(data)), {
							// 手动转化
							type: "base64",
							cellDates: true
						});
					} else {
						$t.wb = XLSX.read(data, {
							type: "binary",
							cellDates: true
						});
					}

					let json = XLSX.utils.sheet_to_json($t.wb.Sheets[$t.wb.SheetNames[0]]);
					// console.log('取到的原始数据==end===========')
					// console.log(json);
					$t.changdata(json);
					$t.element_loading = false;
				};
				if (this.rABS) {
					reader.readAsArrayBuffer(f);
				} else {
					reader.readAsBinaryString(f);
				}

			},
			importExcel2: async function(file) {
				// 导入Excel并解析
				this.element_loading = true;
				let obj = this.imFile;
				if (!obj.files) {
					this.element_loading = false;
					return;
				}
				var f = obj.files[0];
				const types = f.name.split('.')[1];
				// console.log('文件类型 '+types);
				// const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types);
				const fileType = ['xlsx'].some(item => item === types);
				if (!fileType) {
					this.element_loading = false;

					this.$message({
						message: '格式错误！请重新选择',
						type: 'warning'
					});
					return
				}
				let res = await file2Xce(file);
				// console.log(res);
				this.changdata(res);
				this.element_loading = false;

			},
			changdata: function(data) {
				// 转换到指定格式
				// console.log('==start转换==============================');
				// 导入数据格式转换 [{"key":"","val":""},{"key":"","val":""},...]
				this.error_Data = [];
				this.excelData = [];
				this.show_Data = [];
				console.log(data);
				let list_ok = [];
				for (let i = 0; i < data.length; i++) {
					let arr = [];
					for (let m = 0; m < this.tab_th.length; m++) {
						// console.log('name=' + this.tab_th[m].name);   //输出key
						let o = {};
						o.id = m;
						o.key = this.tab_th[m].key;
						o.val = '';
						o.p = this.tab_th[m].p;
						for (let j in data[i]) {
							// console.log('key=' + j); //输出key
							// console.log('val=' + data[i][j]); //输出key对应的value
							if (this.tab_th[m].key == j) {
								if (this.tab_th[m].type == 'date') {
									// console.log('日期=======' + data[i][j]);
									if (data[i][j].toString().length == 8) {
										let t = data[i][j].toString();
										// console.log('日期=======' + t);
										// console.log(t.substring(0, 4) + '-' + t.substring(4, 6) + '-' + t.substring(6, 8));
										o.val = t.substring(0, 4) + '-' + t.substring(4, 6) + '-' + t.substring(6, 8);
									} else {
										o.val = dateFormatEasybyChina(data[i][j]);
									}

								} else if (this.tab_th[m].type == 'datetime') {
									o.val = dateFormatbyChina(data[i][j]);
								} else {

									if (o.val == 'Infinity') {
										console.log(data[i][j]);
										o.val = '';
									} else {
										o.val = (data[i][j]).toString();
									}

								}
								break;
							}
						}
						arr.push(o);
					}
					list_ok.push(arr);
				}

				if (list_ok.length > this.perpage) {
					this.show_page = true;
				} else {
					this.show_page = false;
				}
				this.excelData = [];
				this.excelData = list_ok;
				this.maxpage = Math.ceil(Number(list_ok.length) / Number(this.perpage));
				this.refresh_data();
			},
			refresh_data: function() {
				if (this.excelData.length > this.perpage) {
					this.show_page = true;
				} else {
					this.show_page = false;
				}
				this.show_Data = [];
				var j = 0
				for (var i = 0; i < this.excelData.length; i++) {
					if (i >= ((this.nowpage - 1) * this.perpage) && i < (this.nowpage * this.perpage)) {
						this.show_Data[j] = this.excelData[i];
						j++;
					}
				}
				// console.log(this.show_Data);
			},
			file2Xce: function(file) {
				// 传统方式上传
				return new Promise(function(resolve, reject) {
					const reader = new FileReader()
					reader.onload = function(e) {
						const data = e.target.result
						this.wb = XLSX.read(data, {
							type: 'binary',
							cellDates: true
						})
						const result = []
						this.wb.SheetNames.forEach((sheetName) => {
							result.push({
								sheetName: sheetName,
								sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
							})
						})
						resolve(result)
					}
					// reader.readAsBinaryString(file.raw)
					reader.readAsBinaryString(file) // 传统input方法
				})
			},
			firstpage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage = 1;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			beforepage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage--;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage++;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			lastpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage = this.maxpage;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			gopage: function() {

				if (Number(this.jumppage) > 0 && Number(this.jumppage) <= Number(this.maxpage)) {
					this.nowpage = this.jumppage;
					this.refresh_data();
				} else {
					this.$message({
						message: '跳转页数不在规定范围内,请检查' + this.jumppage,
						type: 'warning'
					});
				}
			},
			savedata: async function() {
				this.error_Data = [];

				for (let i = 0; i < this.excelData.length; i++) {
					for (let j = 0; j < this.excelData[i].length; j++) {
						if (this.excelData[i][j].key == 'ok') {
							if (!checkStringByForm(this.excelData[i][j].val, 'Eng')) {
								this.$message({
									message: '答案=' + this.excelData[i][j].val + ' 包含非英文字符!',
									type: 'warning'
								});
								return;
							}
						}
					}
				}

				this.element_loading = true;
				for (let i = 0; i < this.excelData.length; i++) {
					let d = [];
					for (let j = 0; j < this.excelData[i].length; j++) {
						if (this.excelData[i][j].p == '1') {
							d.push(this.excelData[i][j].val);
						}
					}

					// console.log(d);
					// console.log('api_method==='+this.api_method);
					if (d.length > 0) {
						let res = '';
						switch (this.api_method) {
							case 'base_':
								res = await this.base_update(d);
								break;
							case 'exp15':
								res = await this.exp15_update(d);
								break;
							case 'exp30':
								res = await this.exp30_update(d);
								break;
							case 'exp50':
								res = await this.exp50_update(d);
								break;
						}


						// console.log(res);
						for (let j = 0; j < this.excelData[i].length; j++) {
							// console.log(this.parm[i].val);
							if (this.excelData[i][j].key == 'upflag') {
								this.excelData[i][j].val = res.msg;
							}
						}
						if (res.status == '1') {
							this.$message({
								message: res.msg,
								type: 'success'
							});
						} else {
							this.error_Data.push(this.excelData[i]);
							this.$message({
								message: res.msg,
								type: 'warning'
							});
						}
					}



				}

				// console.log(this.error_Data);

				let that = this;
				setTimeout(function() {
					that.refresh_data();
				}, 6000);

				// 刷新父页面，
				this.$emit('excelup-event');

				this.element_loading = false;
			},
			base_update: function(parm) {

				let d = '';
				for (let i = 0; i < parm.length; i++) {
					// console.log(this.parm[i].val);
					// add 2022-02-15 必须强制删除所有特殊符号，特别是^
					let temp_val = '',
						temp_key = '',
						temp_type = '';
					temp_key = this.tab_th[i + 1].key;
					temp_val = parm[i];

					// if (temp_type == 'time' || temp_type == 'datetime') {
					//   temp_val = dateFormatbyChina(temp_val)
					// }

					// if (temp_type == 'textarea') {
					//   temp_val = temp_val.replace(/\n/g, '<br/>');
					//   temp_val = temp_val.replace(/\s/g, '&nbsp;');
					// }

					d = d + temp_key + '=' + Word_Right_Delete(temp_val) + '^';

				}

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_TableAll('data_' + that.api_action + '_add', this
							.api_check, 0, '', d)
					).then(res => {
						// console.log(res);

						res = JSON.parse(res);
						resolve(res.data)
					});

				});

			},
			exp15_update: function(d) {

				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_Common('data_' + that.api_action + '_add', 0, '', d)
					).then(res => {
						// console.log(res);

						res = JSON.parse(res);
						resolve(res.data)
					});

				});

			},
			exp30_update: function(d, id) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_CommonLong('data_' + that.api_action + '_add', 0, '', d)
					).then(res => {
						console.log(res.data);
						res = JSON.parse(res);
						resolve(res.data)
					});

				});
			},
			exp50_update: function(d, id) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_CommonLongLong('data_' + that.api_action + '_add', 0, '',
							d)
					).then(res => {
						// console.log(res.data);
						res = JSON.parse(res);
						resolve(res.data)
					});

				});
			},
			downloaddata: function() {
				// table2excel
				var myDate = new Date();
				// console.log(this.formatDate(myDate,'yyyy_MM_dd hh_mm_ss'));
				myDate = this.formatDate(myDate, 'yyyy_MM_dd_hh_mm_ss');
				$("#pre_errortable").table2excel({
					exclude: ".noExl",
					name: "table2excel", //文件名称,
					filename: 'down_' + myDate + '.xls',
					exclude_img: true,
					exclude_links: true,
					exclude_inputs: true
				});
			},
			downloaddemo: function() {
				var myDate = new Date();
				// console.log(this.formatDate(myDate,'yyyy_MM_dd hh_mm_ss'));
				myDate = this.formatDate(myDate, 'yyyy_MM_dd_hh_mm_ss');
				$("#pre_demoDetail").table2excel({
					exclude: ".noExl",
					name: "table2excel", //文件名称,
					filename: 'down_' + myDate + '.xls',
					exclude_img: true,
					exclude_links: true,
					exclude_inputs: true
				});
			},
			formatDate(date, fmt = this.format) {
				// 长度为10的时候末尾补3个0
				if (date === null || date === "null") {
					return "--";
				}
				date = new Date(Number(date));
				var o = {
					"M+": date.getMonth() + 1, // 月份
					"d+": date.getDate(), // 日
					"h+": date.getHours(), // 小时
					"m+": date.getMinutes(), // 分
					"s+": date.getSeconds(), // 秒
					"q+": Math.floor((date.getMonth() + 3) / 3), // 季度
					S: date.getMilliseconds() // 毫秒
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(
						RegExp.$1,
						(date.getFullYear() + "").substr(4 - RegExp.$1.length)
					);
				for (var k in o) {
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(
							RegExp.$1,
							RegExp.$1.length === 1 ?
							o[k] :
							("00" + o[k]).substr(("" + o[k]).length)
						);
				}
				return fmt;
			}
		}
	};
</script>


<style scoped>
	.pre_tan_conten {
		position: fixed;
		width: 80%;
		height: auto;
		left: 10%;
		top: 8%;
		/* background: #faf5f5; */
		background-color: azure;
		border-radius: 5px;
		max-height: 84%;
		z-index: 32;
		overflow-y: hidden;
		overflow-x: auto;

	}

	.pre_leve_two {
		overflow-y: hidden;
	}

	/* pre_search */
	.pre_btn {
		text-align: left;
	}

	.pre_btn>label {
		position: relative;
		/* left: 2%; */
	}

	.pre_btn>input {
		position: relative;
		/* left: 2%; */
	}

	.pre_btn>input :focus {
		border: 1px solid #024aee;
		background-color: #aaa;
	}



	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_dataintable {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;
		overflow-y: hidden;

	}

	/* .pre_dataintable thead {
    display: table-row;
  }

  .pre_dataintable tbody {
    overflow-y: scroll;
    overflow-x: hidden;
    display: block;
    max-height: calc(100vh - 300px);

  } */

	.pre_dataintable td {
		padding: 2px 6px 2px 6px;
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 48px;
		/* width: auto; */
		max-width: 256px;
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
	}

	.tab_header td {
		background-color: rgb(87, 201, 230);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		/* border: 1px solid #808080; */

	}

	/* 首列是ID,不排序,隐藏 */
	.pre_dataintable tr td:nth-child(1) {
		/* display: none; */
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	/*  .pre_dataintable tr td:nth-child(2) {
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  } */

	.pre_dataintable tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		height: 25px;
		line-height: 25px;
	}

	/* 表格内按钮 */
	.pre_dataintable td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/* 表格内输入框 */
	.pre_dataintable td input {
		width: 100%;
		height: 100%;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
	}

	.pre_dataintable td img {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 5px;
		margin-right: 5px;
	}

	.pre_dataintable td img:hover {
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_dataintable td span {
		display: inline-block;
		border: 1px solid black;
		background: #aaa;
		text-align: center;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 2px;
		margin-right: 2px;
	}

	.pre_dataintable tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_dataintable tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_dataintable tr:hover {
		background-color: #b8f8b8 !important;
	}

	/*  .pre_dataintable tr:focus {
    background: #92a4f3 !important;
  } */
	/* 取消a标签的默认样式 */
	a {
		/* display: block; */
		height: 100%;
		text-decoration: none;
		color: #333;
	}

	.pre_dataintable tr>td>a:focus {
		background: #92a4f3 !important;
	}


	.tab_add {
		width: 95%;
		display: flex;
		margin-top: 5px;
		margin-left: 2%;
		background-color: rgba(103, 233, 77, 0.644);
	}

	.tab_upd {
		width: 95%;
		display: flex;
		margin-left: 2%;
		background-color: rgba(209, 212, 36, 0.644);
	}

	/* 翻页样式 */
	.pre_page {
		width: 100%;
		margin-top: -12px;
		/* padding-bottom: 5px; */
	}

	.pre_page>ul {
		text-align: right;
		list-style: none;
	}

	.pre_page>ul>li>label {
		width: 24px;
		min-width: 24px;
	}

	.pre_page>ul>li>input {
		width: 48px;
		min-width: 48px;
	}

	.pre_page>ul>li>a {
		text-decoration: none;
	}

	.pre_page>ul>li>.go {
		display: inline-block;
		width: 30px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_page>ul>li>a:hover {
		color: #394656;
	}
</style>
